jQuery(document).ready(function ($) {

    $('.bloc_bandeau').each(function () {
        const $block = $(this)
        const items = $block.find('.card').get()
        if (!items.length) return

        gsap.from(items, {
            y: 300,
            ease: "power3.out",
            scrollTrigger: {
                trigger: $block[0],
                start: 'top 90%',
                end: 'bottom 98%',
                scrub: .8
            }
        })


    })
})
